import mixpanel from 'mixpanel-browser'
import React from 'react'
import initMixpanel from 'src/utils/initMixpanel'

import { MixPanelContext } from './constants'
import { useOptimizely } from './useOptimizely'


const MixpanelProvider = ({ children }: { children: React.ReactNode }) => {
  const newSalesJourneyDecision = useOptimizely('new-sales-journey')
  const newSalesJourney = newSalesJourneyDecision.variationKey ?? false

  initMixpanel()

  mixpanel.identify()

  // document is not available during server side rendering.
  if (typeof document !== 'undefined') {
    mixpanel.people.set({ OptimizelySignUpVariant: newSalesJourney })
  }

  return <MixPanelContext.Provider value={mixpanel}>{children}</MixPanelContext.Provider>
}

export default MixpanelProvider
